import { render, staticRenderFns } from "./footer-layout.vue?vue&type=template&id=c46c9b46"
import script from "./footer-layout.vue?vue&type=script&lang=js"
export * from "./footer-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports